import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ICONS_LIST } from './icons-list';
import { IIcon } from './bueno-icon.types';

@Injectable({ providedIn: 'root' })
export class IconsFactory {
  public icons: IIcon[] = [];

  constructor(
    private _matIconRegistory: MatIconRegistry,
    private _domSanitizer: DomSanitizer
  ) {}

  public init() {
    this._setConfigIcons();
    this._registration();
  }

  private _setConfigIcons() {
    this.icons = ICONS_LIST;
  }

  private _registration() {
    this.icons.forEach(icon => {
      this._matIconRegistory.addSvgIcon(icon.name, this._domSanitizer.bypassSecurityTrustResourceUrl(icon.path));
    });
  }
}
